import { Controller } from "@hotwired/stimulus"

// Keeps "I've added a payment method" disabled until the student opens
// Heroku billing, so that step is not skipped.
export default class extends Controller {
  static targets = [ "confirm" ]

  unlock() {
    this.confirmTarget.disabled = false
  }
}
